import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useTheme } from '@emotion/react';
import Icon from './Icon';
const TonalIcon = (props) => {
    const theme = useTheme();
    const contentColor = props.contentColor ?? theme.color.primary;
    const containerColor = props.containerColor ?? `color-mix(in srgb, ${contentColor}, transparent 90%)`;
    return _jsx(Icon, { ...props, containerColor: containerColor, contentColor: contentColor });
};
export default TonalIcon;
//# sourceMappingURL=TonalIcon.js.map